import Date_ from './Date_'

export default class After extends Date_ {
  get ruleName () {
    return 'after'
  }

  passes () {
    return this.momentFormat(this.value).isAfter(this.momentFormat(this.date), 'day')
  }
}
